'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getKey = getKey;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragList = require('./DragList');

var _DragList2 = _interopRequireDefault(_DragList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by corupta on 20/07/17.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
/* eslint-env browser */


var lastKey = 0;

function getKey() {
  return 'xyq_' + lastKey++;
}

var hrStyle = {
  height: 2,
  borderWidth: 0,
  color: 'currentColor',
  backgroundColor: 'currentColor'
};

var DragDrop = function (_React$Component) {
  _inherits(DragDrop, _React$Component);

  function DragDrop(props) {
    _classCallCheck(this, DragDrop);

    return _possibleConstructorReturn(this, (DragDrop.__proto__ || Object.getPrototypeOf(DragDrop)).call(this, props));
  }

  _createClass(DragDrop, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var topElemSticks = typeof nextProps.topElemSticks === 'undefined' ? true : nextProps.topElemSticks;
      var bottomElemSticks = typeof nextProps.bottomElemSticks === 'undefined' ? true : nextProps.bottomElemSticks;
      this.topElem = null;
      this.innerTopElem = null;
      if (typeof nextProps.topElem !== 'undefined') {
        var topElem = _react2.default.createElement(
          'div',
          { style: { width: '100%', marginBottom: 'auto' } },
          nextProps.topElem,
          _react2.default.createElement('hr', { style: _extends({}, hrStyle, { marginTop: 0 }) })
        );
        if (topElemSticks) {
          this.topElem = topElem;
        } else {
          this.innerTopElem = topElem;
        }
      }
      this.bottomElem = null;
      this.innerBottomElem = null;
      if (typeof nextProps.bottomElem !== 'undefined') {
        var bottomElem = _react2.default.createElement(
          'div',
          { style: { width: '100%', marginTop: 'auto' } },
          _react2.default.createElement('hr', { style: _extends({}, hrStyle, { marginBottom: 0 }) }),
          nextProps.bottomElem
        );
        if (bottomElemSticks) {
          this.bottomElem = bottomElem;
        } else {
          this.innerBottomElem = bottomElem;
        }
      }
      this.style = {};
      if (typeof nextProps.style !== 'undefined') {
        if (typeof nextProps.style.overflow !== 'undefined') {
          this.style.overflow = nextProps.style.overflow;
        }
        if (typeof nextProps.style.overflowX !== 'undefined') {
          this.style.overflowX = nextProps.style.overflowX;
        }
        if (typeof nextProps.style.overflowY !== 'undefined') {
          this.style.overflowY = nextProps.style.overflowY;
        }
      }
      this.myStyle = typeof nextProps.style !== 'undefined' ? _extends({}, nextProps.style) : {};
      this.myStyle.overflow = 'hidden';
      this.myStyle.overflowX = 'hidden';
      this.myStyle.overflowY = 'hidden';
    }
  }, {
    key: 'render',
    value: function render() {
      var tag = typeof this.props.tag === 'undefined' ? 'div' : this.props.tag;
      return _react2.default.createElement(tag, { style: this.myStyle, className: this.props.class === 'undefined' ? '' : this.props.class }, _react2.default.createElement('div', { style: { display: 'flex', alignItems: 'center', height: '100%', width: '100%', flexDirection: 'column' } }, this.topElem !== null && this.topElem, _react2.default.createElement(
        _DragList2.default,
        {
          myGid: this.props.myGid,
          dragName: this.props.dragName,
          dropName: this.props.dropName,
          removeItem: this.props.removeItem,
          insertItem: this.props.insertItem,
          dropFunc: this.props.dropFunc,
          style: this.style,
          animationDuration: this.props.animationDuration,
          itemClass: this.props.itemClass,
          topElem: this.innerTopElem,
          bottomElem: this.innerBottomElem,
          scrollWhen: this.props.scrollWhen,
          scrollSpeed: this.props.scrollSpeed,
          delayOnTouch: this.props.delayOnTouch,
          delayOnMouse: this.props.delayOnMouse,
          rotateFlying: this.props.rotateFlying,
          lockX: this.props.lockX
        },
        this.props.children
      ), this.bottomElem !== null && this.bottomElem));
    }
  }]);

  return DragDrop;
}(_react2.default.Component);

exports.default = DragDrop;


_DragList2.default.PropTypes = {
  myGid: _propTypes2.default.number.isRequired,
  dragName: _propTypes2.default.string,
  dropName: _propTypes2.default.string,
  removeItem: _propTypes2.default.func,
  insertItem: _propTypes2.default.func,
  dropFunc: _propTypes2.default.func,
  style: _propTypes2.default.shape(),
  animationDuration: _propTypes2.default.func,
  class: _propTypes2.default.string,
  itemClass: _propTypes2.default.string,
  topElem: _propTypes2.default.element,
  bottomElem: _propTypes2.default.element,
  topElemSticks: _propTypes2.default.bool,
  bottomElemSticks: _propTypes2.default.bool,
  scrollWhen: _propTypes2.default.number,
  scrollSpeed: _propTypes2.default.number,
  delayOnTouch: _propTypes2.default.number,
  delayOnMouse: _propTypes2.default.number,
  rotateFlying: _propTypes2.default.bool,
  lockX: _propTypes2.default.bool
};

_DragList2.default.defaultProps = {
  dragName: '',
  dropName: '',
  animationDuration: 250,
  scrollWhen: 48,
  scrollSpeed: 1.0,
  // at least 12 or you are probably going to have some issues on mobile devices
  delayOnTouch: 400,
  delayOnMouse: 0,
  rotateFlying: true,
  lockX: false
};
/*
clone: true => clone
ondragend do nothing

both
ondrop -> reH: true

clone: false => move item to out of bounds
ondragend if drop succesfull => remove item, recalculate itemHeights automagically

(minus)blankH if more than blank
(minus)draggedH if more than draggedId

ondragleave removes the blank so no need to remove blank ever again
 */


//////////////////
// WEBPACK FOOTER
// ./~/drag-drop-list-react/dist/index.js
// module id = 90
// module chunks = 0